import { reinitialise as reinitialiseCustomerItems } from "./initialise/customerItems/reinitialise";
import { reinitialise as reinitialiseSharedBoard } from "./initialise/sharedBoard/reinitialise";
import { reinitialise as reinitialiseSimilarItems } from "./initialise/similarItems/reinitialise";
import { getItemsType } from "../modules/common/selectors";
import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD,
  ITEMS_TYPE_SIMILAR
} from "../../constants";

export const reinitialise = () => (dispatch, getState) => {
  const itemsType = getItemsType(getState());

  const specificReInitialisation = {
    [ITEMS_TYPE_SIMILAR]: reinitialiseSimilarItems,
    [ITEMS_TYPE_CUSTOMER_ITEMS]: reinitialiseCustomerItems,
    [ITEMS_TYPE_SHARED_BOARD]: reinitialiseSharedBoard
  }[itemsType];

  dispatch(specificReInitialisation());
};
